import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Add, Replay } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';

import BangSachIsert from '../BangSachInsert';

import { monographActions } from '../../../../actions';

export default function BangSachButton(props) {
  const dispatch = useDispatch();
  const profileId = useSelector(state => state.profileReducer.profile?.id);
  const totalMonographList = useSelector(state => state.monographReducer.totalMonographList);
  const personalMonographList = useSelector(state => state.monographReducer.personalMonographList);

  const [inserting, setInserting] = useState(false);

  const handleClick = () => setInserting(true);
  const handleClose = () => setInserting(false);
  const handleReload = () => {
    if (props.filterType === 'person') {
      dispatch(monographActions.getMonographsByProfileId(profileId));
    } else {
      dispatch(monographActions.getAllMonograph());
    }
  }

  useEffect(() => {
    if (props.filterType === 'person' && !isNaN(profileId) && personalMonographList.length === 0) handleReload();
  }, [profileId]);

  useEffect(() => {
    if (props.filterType === 'all' && totalMonographList.length === 0) handleReload();
  }, []);


  return (
    <>
      <Grid item xs={12} md={3}>
        <div style={{ float: 'right' }}>
          <Button variant='outlined' startIcon={<Replay />} onClick={handleReload}>Tải lại</Button>
          {props.filterType === 'person' && (
            <Button variant='contained' color='secondary' startIcon={<Add />} style={{ marginLeft: 8 }} onClick={handleClick}>Thêm</Button>
          )}
        </div>
      </Grid>


      <BangSachIsert open={inserting} onClose={handleClose} />
    </>
  );
}
